<template>
  <div class="modal fade" id="fsImageModal" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <img id="fsImageDisplay" :alt="file.name" />
      </div>
    </div>
  </div>
  <div class="form-control">
    <div class="d-flex flex-wrap-reverse" dir="ltr">
      <div class="col-md-2 col-12 ms-auto order-1 me-1 mb-0 mt-1">
        <label for="fsInputFile" class="btn bg-secondary text-white w-100 mt-0 mb-1 file-selector-button">
          افزودن فایل
          <input class="form-control d-none" type="file" id="fsInputFile" @change="filesSelected" multiple />
        </label>
      </div>
      <div v-for="(file, index) in files" class="mt-1 me-0 col-md-3 col-12">
        <button type="button" class="btn bg-danger file-selector-remove mb-0" @click="removeFile(index)">
          <span type="button" class="btn-close" aria-label="close"></span>
        </button>
        <button type="button" class="btn text-truncate file-selector-open mb-0" :title="file.name"
          @click="openFile(file)">
          {{ file.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['maxFileCount', 'maxFileSize', 'validExtensions'],
  emits: ['filesUpdate'],
  data() {
    return {
      files: [],
      file: {},
      imageSrc: '',
    }
  },
  watch: {
    files(files) {
      this.$emit('filesUpdate', files);
    },
  },
  methods: {
    filesSelected() {
      let newFiles = document.getElementById('fsInputFile').files;
        if (newFiles.length == 0) { return; }
        
        newFiles = [...newFiles];

        for(let file of newFiles) {
          let fileNameArray = file.name.split('.').map(String);

          if (this.validExtensions?.length > 0 & !this.validExtensions.includes(fileNameArray[fileNameArray.length - 1])) {
            this.$toast.error('پسوند حداقل یکی از فایل‌ها مجاز نیست');
            return;
          }

          if (this.maxFileSize != null & file.size > this.maxFileSize) {
            this.$toast.error('حجم حداقل یکی از فایل‌ها بیش از سقف مجاز است');
            return;
          }
        }

        let filesArray = [...this.files, ...newFiles];
        if (filesArray.length > this.maxFileCount) {
          this.$toast.error(`حد اکثر می‌توانید ${this.maxFileCount} انتخاب کنید`);

          return;
        }

        let dataTransfer = new DataTransfer();
        filesArray.forEach(x => dataTransfer.items.add(x));

        this.files = dataTransfer.files;
    },
    removeFile(index) {
      let filesArray = [...this.files];
      filesArray.splice(index, 1);

      let dataTransfer = new DataTransfer();
      filesArray.forEach(x => dataTransfer.items.add(x));

      this.files = dataTransfer.files;
    },
    openFile(file) {
      if (file?.type?.startsWith('image/')) {
        let fileReader = new FileReader();

        fileReader.onload = function (e) {
          document.getElementById('fsImageDisplay').src = e.target.result;
        }

        fileReader.readAsDataURL(file);

        this.file = file;

        var imageModal = new bootstrap.Modal(document.getElementById('fsImageModal'));
        imageModal.show();
      }
    },
  },
}
</script>